import type { PolicySettings } from './contracts';

/** Starting points copied into ordinary drafts, never a live binding or execution authority. */
export const policyProfiles = [
  { id: 'workstation', name: 'Workstation', description: 'Security and quality updates. No automatic restarts. Everyone update ring.',
    settings: { patchApproval: 'security-quality', reboot: 'never', updateRing: 'everyone' } },
  { id: 'server', name: 'Server', description: 'Security updates only. No automatic restarts.',
    settings: { patchApproval: 'security', reboot: 'never' } },
] as const;
export type PolicyProfileId = typeof policyProfiles[number]['id'];

/** Keep windows, exclusions and protection exceptions; the caller also keeps reasons, expiry and locks. */
export function profileSettings(current: Partial<PolicySettings>, profile: PolicyProfileId | 'inherit'): Partial<PolicySettings> {
  const settings = structuredClone(current);
  if (profile === 'inherit') {
    delete settings.patchApproval;
    delete settings.reboot;
    delete settings.updateRing;
  } else {
    // A profile without a Windows Update ring (Server: servers are out of WRMM-328's scope) clears one an earlier profile set.
    delete settings.updateRing;
    Object.assign(settings, policyProfiles.find(p => p.id === profile)!.settings);
  }
  return settings;
}
